import { api } from '../api';

export interface MemoAuthor {
  id: string;
  nickname: string;
  role: 'ADMIN' | 'MANAGER' | 'STAFF';
}

export interface Memo {
  id: string;
  residentId: string;
  content: string;
  author: MemoAuthor;
  createdAt: string;
  updatedAt: string;
  editableByMe: boolean;
}

export async function listMemos(residentId: string): Promise<Memo[]> {
  const res = await api.get<Memo[]>(`/residents/${residentId}/memos`);
  return res.data;
}

export async function createMemo(residentId: string, content: string): Promise<Memo> {
  const res = await api.post<Memo>(`/residents/${residentId}/memos`, { content });
  return res.data;
}

export async function updateMemo(
  residentId: string,
  memoId: string,
  content: string,
): Promise<Memo> {
  const res = await api.put<Memo>(`/residents/${residentId}/memos/${memoId}`, { content });
  return res.data;
}

export async function deleteMemo(residentId: string, memoId: string): Promise<{ id: string }> {
  const res = await api.delete<{ id: string }>(`/residents/${residentId}/memos/${memoId}`);
  return res.data;
}
